import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorLinkWithThePlaceFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorLinkWithThePlaceField: FC<CryptorLinkWithThePlaceFieldProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="linkWithThePlace"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Lien avec le lieu"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorLinkWithThePlaceField;
